import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Alert } from '@emburse/ui-core';
export const parseAndGetErrorMessage = function (errorMessage) {
    if (!errorMessage)
        return;
    let errorMessageParsed = errorMessage;
    try {
        const parsed = JSON.parse(errorMessage);
        errorMessageParsed = parsed.error || errorMessage;
    }
    catch (e) { }
    return errorMessageParsed;
};
export const ErrorAlert = ({ errorMessage }) => {
    const errorMessageParsed = parseAndGetErrorMessage(errorMessage);
    return (_jsx(Alert, Object.assign({ severity: 'error', className: 'error-alert' }, { children: errorMessageParsed })));
};
